import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "disabled", "disabledText", "valueKey", "options", "values"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @class MultiOtherPicker
 *
 * this component wraps `select` and adds some processing for `other` values.
 *
 */
import { filter, find, isArray, isObject } from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import MultiPicker from './multiPicker';
const MultiOtherPicker = _ref => {
  let _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$disabledText = _ref.disabledText,
    disabledText = _ref$disabledText === void 0 ? '' : _ref$disabledText,
    _ref$valueKey = _ref.valueKey,
    valueKey = _ref$valueKey === void 0 ? 'id' : _ref$valueKey,
    options = _ref.options,
    values = _ref.values,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  /**
   * @method prepareOptions - we need to make sure any "other" values are included
   * in the option list
   * or they won't be shown in the list of values selected.  Note they dont
   * get displayed in the option list, but (ironically) they must exist in
   * the list.
   */
  const prepareOptions = () => {
    let result = JSON.parse(JSON.stringify(options));

    // this bit of logic is to handle adding in "other" values to the options
    // list.  I could break this out into a wrapper component instead of having it here.
    if (isArray(values)) {
      if (values.length > 0 && isObject(values[0])) {
        // include the value if it is NOT found in the option list.
        const valuesNotInOptions = filter(values, val => !find(options, option => option[valueKey] === val[valueKey]));
        result = result.concat(valuesNotInOptions);
      }
    }
    return result;
  };
  const newProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    // with MultiOtherPicker, allowCreate is always true.
    allowCreate: true,
    options: prepareOptions(),
    className: "".concat(className, " t-mop"),
    disabled,
    disabledText,
    valueKey,
    values
  });
  return /*#__PURE__*/React.createElement(MultiPicker, newProps);
};
MultiOtherPicker.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledText: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  valueKey: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])).isRequired
};
export default MultiOtherPicker;